import React from "react";
import Card from "components/card";
import { formatDuration } from "common/validation";
import { useLocation } from "react-router-dom";
import TransectionPage from "../transectionPage";

const UserDetailsPage = () => {
    const location = useLocation();
  const userDetails = location.state?.userDetails || {};
    const {
    name, app_id, email, _id, city, state, country, pinCode,
    religion, date_of_birth, gender, host_margin,
    is_subscription_done, social_media_type,
    top_up_Amount, current_top_amount,
    hobbies, interests, languages, music_taste,
    avatar, banner,isHost
  } = userDetails;
    const dobStr = date_of_birth
    ? new Date(date_of_birth).toLocaleDateString()
    : 'Not Available';

  const topUpPercent = top_up_Amount > 0
    ? ((current_top_amount / top_up_Amount) * 100).toFixed(0)
    : '0';
  return (
    <>
<Card extra="mt-3 !z-5 overflow-hidden">
  {/* Header */}
  <div className="flex items-center justify-between rounded-t-3xl p-3">
    <h3 className="text-lg font-bold text-navy-700 dark:text-white">
      User Profile & Activity
    </h3>
    {/* <button className="rounded-full bg-lightPrimary px-3 py-1 text-sm font-medium text-brand-500 hover:bg-gray-100 dark:bg-white/5 dark:hover:bg-white/10">
      See all
    </button> */}
  </div>

  {/* Content */}
  {userDetails?.email ? (
    <>
    <div className="flex-col items-start space-x-4 bg-white p-4 hover:shadow-lg dark:bg-navy-800 dark:hover:bg-navy-700">
    <div className="flex items-start space-x-4 bg-white p-4 ">
      {/* Avatar */}
      <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gray-100 overflow-hidden">
        <img
          src={
            userDetails.img_Url ||
            `https://ui-avatars.com/api/?name=${encodeURIComponent(userDetails.name)}&background=ddd&color=555`
          }
          alt={userDetails.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Main Info */}
   <div className="pt-16 pb-6 px-6">
        {/* Name & Email */}
        <h4 className="text-xl font-semibold text-gray-900 dark:text-white truncate">
          {name} ({app_id || '####'})
        </h4>
        <p className="text-sm text-gray-600 dark:text-gray-400 truncate">
          {email}
        </p>

        {/* Grid Info */}
        <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-gray-600 dark:text-gray-400">
          <div><span className="font-medium dark:text-gray-200">User ID:</span> {_id}</div>
          <div><span className="font-medium dark:text-gray-200">Location:</span> {city}, {state}</div>
          <div><span className="font-medium dark:text-gray-200">Country/PIN:</span> {country}, {pinCode}</div>
          <div><span className="font-medium dark:text-gray-200">DOB:</span> {dobStr}</div>
          <div><span className="font-medium dark:text-gray-200">Gender:</span> {gender || 'N/A'}</div>
          <div><span className="font-medium dark:text-gray-200">Religion:</span> {religion}</div>
          <div><span className="font-medium dark:text-gray-200">Top‑up %:</span> {topUpPercent}%</div>
          <div><span className="font-medium dark:text-gray-200">Host Margin:</span> {host_margin > 0 ? host_margin : 0}</div>
          <div><span className="font-medium dark:text-gray-200">Subscription:</span> {is_subscription_done ? '✔️ Completed' : '⚠️ Pending'}</div>
          <div><span className="font-medium dark:text-gray-200">Social:</span> {social_media_type || 'N/A'}</div>
        </div>

        {/* Badges */}
        <div className="mt-4 flex flex-wrap gap-2">
          {hobbies && <span className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-0.5 rounded-full text-xs">🎯 {hobbies.join(', ')}</span>}
          {interests && <span className="bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 px-2 py-0.5 rounded-full text-xs">🔍 {interests.join(', ')}</span>}
          {languages && <span className="bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-2 py-0.5 rounded-full text-xs">🗣️ {languages.join(', ')}</span>}
          {music_taste && <span className="bg-pink-100 dark:bg-pink-900 text-pink-800 dark:text-pink-200 px-2 py-0.5 rounded-full text-xs">🎵 {music_taste.join(', ')}</span>}
        </div>
      </div>
</div>
<div>
{!isHost &&  <TransectionPage type="user-transection" userId={_id} />}
</div>
      <div className="flex-shrink-0 text-right text-gray-700 dark:text-gray-200">
        <p className="text-md text-dark font-medium mb-4">Logs History</p>
        {(() => {
          const lastLog = userDetails.logs?.[0];
          if (!lastLog) return <p className="text-sm font-medium">No activity</p>;

          const mins = Math.floor((Date.now() - new Date(lastLog.createdAt)));
          return (
            <>
              <p className="text-sm font-medium">{lastLog.action}</p>
              <p className="text-xs text-gray-500 mt-1">{formatDuration(mins)}</p>
              <p className="text-xs text-gray-500 mt-1">
                by {lastLog.performedBy.name}
              </p>
            </>
          );
        })()}
      </div>
      </div>
      </>) :
    <div className="flex items-center justify-center h-48 bg-gray-100 dark:bg-navy-800 rounded-lg">
      <p className="text-gray-500 dark:text-gray-400">No user details available please click any profile button to view details</p>
    </div>  
  }
</Card>
</>

  );
};

export default UserDetailsPage;
